<template>
	<div class="card-option-item-link">
		<button @click="actionGoTo" class="card-option-item-link__button">
			<span>{{ title }}</span>
		</button>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'card-option-item-link',
	props: {
		route: {
			type: String,
			default: null
		},
		routeStartsWith: {
			type: String,
			default: null
		},
		title: {
			type: String,
			default: null
		},
		args: {
			type: Object,
			default: () => {}
		}
	},
	methods: {
		actionGoTo() {
			if (!this.route)
				return

			this.$router.push({
				name: this.route,
				params: Object.assign({}, {
					user_uid: this.currentUser.uid
				}, this.args)
			})

			this.$parent.$emit('close')
		}
	},
	computed: {
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	}
}
</script>

<style scoped>
a > span,
button > span {
	transform: translate(0, 0);
	transition: all 300ms;
	display: inline-block;
}
a:hover > span,
button:hover > span {
	transform: translate(5px, 0);
	font-weight: 700;
}
.card-option-item-link {
	padding: 0;
	position: relative;
	width: 100%;
}
.card-option-item-link__button {
	border: 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.25);
	background: transparent;
	color: #fff;
	font-size: 14px;
	font-weight: 300;
	box-sizing: border-box;
	cursor: pointer;
	text-decoration: none;
	outline: none;
	position: relative;
	transition: color 0.3s;
	width: 100%;
	display: flex;
	justify-content: center;
	padding: 10px;
}
.card-option-item-link__button > span {
	padding: 7px 0;
	display: block;
	white-space: nowrap;
}
.card-option-item-link:last-child .card-option-item-link__button {
	border-bottom: 1px solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/modules/common/CardOptionItemLink.vue